import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-timeline-label',
    templateUrl: './timeline-label.component.html',
    styleUrls: ['./timeline-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class TimelineLabelComponent {
    constructor() {
    }
}
